<section class="home_section">
  <div class="home__container">
    <!-- Hero Section -->
    <div class="home__hero">
      <canvas #heroCanvas class="home__hero-canvas" aria-hidden="true"></canvas>
      
      <div class="about__logo-container">
        <img [src]="logoSrc" alt="Corvus TID" class="about__logo">
      </div>
      <h3 class="home__subtitle">
        Innovación, Automatización y Conectividad Inteligente
      </h3>
      <p class="home__description">
        Impulsamos la transformación digital de empresas, industrias y hogares a través de soluciones de automatización,
        domótica e integración tecnológica.
        Conecta tus procesos, controla tus dispositivos y lleva tu productividad al siguiente nivel con Corvus TID.
      </p>
    </div>

    <!-- Secciones de Resumen -->
    <div class="sections__grid">
      <!-- Acerca de -->
      <div class="section__card" *ngFor="let section of sections">
        <div class="section__icon">
          <i [class]="section.icon"></i>
        </div>
        <h3 class="section__title">{{ section.title }}</h3>
        <p class="section__description">{{ section.description }}</p>
        <a (click)="navigateTo(section.route)" class="section__button">
          Ver más
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>

    <!-- Call to Action -->
    <div class="home__cta">
      <h2 class="cta__title">¿Listo para llevar tu negocio al siguiente nivel?</h2>
      <p class="cta__description">Contáctanos hoy y descubre cómo podemos ayudarte</p>
      <a (click)="navigateTo('/contact')" class="cta__button">
        Contáctanos ahora
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
        </svg>
      </a>
    </div>
  </div>
</section>